import React from 'react'
import './change-pwd.less'
import { Toast } from 'antd-mobile'
import { setHeader } from '@/util/set-header'
import { withRouter } from 'react-router-dom'
import { fetchChangePwd } from '@/api/change-pwd'

@(withRouter as any)
export default class ChangePwd extends React.Component<any, any> {
    init_pwd: HTMLInputElement | null = null
    new_pwd: HTMLInputElement | null = null
    again_pwd: HTMLInputElement | null = null

    constructor(props: any) {
        super(props)
        this.state = ({
            length: 20,
            init_pwd: '',
            new_pwd: '',
            again_pwd: '',
            init_line: false,
            new_line: false,
            again_line: false,
            init_pwd_see: false,
            new_pwd_see: false,
            again_pwd_see: false,
            init_type: 'password',
            new_type: 'password',
            again_type: 'password',
        })
    }

    UNSAFE_componentWillMount() {
        setHeader({
            title: '修改密码',
            leftClick: this.leftClick,
        })
    }

    leftClick() {
        //返回App
        if (window.WebViewBridge) {
            window.WebViewBridge.navBackMarket()
        } else if (window.webkit) {
            window.webkit.messageHandlers.navBackMarket.postMessage('')
        }
    }

    /**
     * 原密码获取焦点
     */
    init_pwd_focus = () => {
        this.setState({
            init_line: true,
        })
    }

    init_pwd_blur = () => {
        this.setState({
            init_line: false,
        })
    }

    /**
     * 新密码获取焦点
     */
    new_pwd_focus = () => {
        this.setState({
            new_line: true,
        })
    }

    new_pwd_blur = () => {
        this.setState({
            new_line: false,
        })
    }

    /**
     * 再次输入密码获取焦点
     */
    again_pwd_foucs = () => {
        this.setState({
            again_line: true,
        })
    }

    again_pwd_blur = () => {
        this.setState({
            again_line: false,
        })
    }

    /**
     * 原密码
     */
    init_pwd_state = (pwd: any) => {
        this.setState({
            init_pwd: pwd,
            init_pwd_see: pwd === '' ? false : true,
        })
    }

    /**
     * 新密码
     */
    new_pwd_state = (pwd: any) => {
        this.setState({
            new_pwd: pwd,
            new_pwd_see: pwd === '' ? false : true,
        })
    }

    /**
     * 确认密码
     */
    again_pwd_state = (pwd: any) => {
        this.setState({
            again_pwd: pwd,
            again_pwd_see: pwd === '' ? false : true,
        })
    }

    /**
     * 展示原密码
     */
    show_init_pwd = () => {
        this.init_pwd?.focus()
        this.setState({
            init_type: (this.state.init_type === 'password') ? 'text' : 'password',
        })
    }

    /**
     * 展示新密码
     */
    show_new_pwd = () => {
        this.new_pwd?.focus()
        this.setState({
            new_type: (this.state.new_type === 'password') ? 'text' : 'password',
        })
    }

    /**
     * 展示确认密码
     */
    show_again_pwd = () => {
        this.again_pwd?.focus()
        this.setState({
            again_type: (this.state.again_type === 'password') ? 'text' : 'password',
        })
    }

    /**
     * 确定
     */
    ensure_pwd = async () => {
        if (this.state.init_pwd === '') {
            Toast.show('原密码不能为空')
            return
        }
        if (this.state.new_pwd === '') {
            Toast.show('新密码不能为空')
            return
        }
        if (this.state.again_pwd === '') {
            Toast.show('新密码不能为空')
            return
        }
        if (this.state.new_pwd !== this.state.again_pwd) {
            Toast.show('两次密码不一致')
            return
        }

        const param = {
            old_passwd: this.state.init_pwd,
            new_passwd: this.state.again_pwd
        }

        Toast.show('加载中')
        const data = await fetchChangePwd(param)
        if (data.code !== 'SUCCESS') {
            Toast.show(data.msg)
        } else {
            Toast.show('修改密码成功，请重新登录')
            if (window.WebViewBridge) {
                window.WebViewBridge?.logout()
            } else if (window.webkit) {
                window.webkit.messageHandlers.logout.postMessage(null)
            }
        }
    }

    render() {
        let InitPwdIcon = this.state.init_type === 'text' ? <i className="iconfont" onClick={this.show_init_pwd}>&#xe640;</i> : <i className="iconfont" onClick={this.show_init_pwd}>&#xe819;</i>
        let NewPwdIcon = this.state.new_type === 'text' ? <i className="iconfont" onClick={this.show_new_pwd}>&#xe640;</i> : <i className="iconfont" onClick={this.show_new_pwd}>&#xe819;</i>
        let AgainPwdIcon = this.state.again_type === 'text' ? <i className="iconfont" onClick={this.show_again_pwd}>&#xe640;</i> : <i className="iconfont" onClick={this.show_again_pwd}>&#xe819;</i>

        let InitPwdImg = this.state.init_line ? '/public/assets/img/ic_password_focus.png' : '/public/assets/img/ic_password_normal.png'
        let NewPwdImg = this.state.new_line ? '/public/assets/img/ic_password_focus.png' : '/public/assets/img/ic_password_normal.png'
        let AgainPwdImg = this.state.again_line ? '/public/assets/img/ic_password_focus.png' : '/public/assets/img/ic_password_normal.png'

        return (
            <div className="change-pwd">
                <div className="line">
                    <div className="pwd-edit-item">
                        <div className="pwd-edit">
                            <img className="img" src={InitPwdImg} alt="" />
                            <input
                                ref={(input) => { this.init_pwd = input; }}
                                onFocus={this.init_pwd_focus}
                                onBlur={this.init_pwd_blur}
                                type={this.state.init_type}
                                maxLength={20}
                                placeholder='原密码'
                                onChange={(v) => { this.init_pwd_state(v.currentTarget.value) }}
                            />
                        </div>
                        {this.state.init_pwd_see && InitPwdIcon}
                    </div>
                    <div className="under-line">
                        <div className={this.state.init_line ? 'red-line' : 'gray-line'}></div>
                    </div>
                    <div className="pwd-edit-item">
                        <div className="pwd-edit">
                            <img className="img" src={NewPwdImg} alt="" />
                            <input
                                onFocus={this.new_pwd_focus}
                                onBlur={this.new_pwd_blur}
                                type={this.state.new_type}
                                maxLength={20}
                                placeholder='新密码'
                                onChange={(v) => { this.new_pwd_state(v.currentTarget.value) }}
                            />
                        </div>
                        {this.state.new_pwd_see && NewPwdIcon}
                    </div>
                    <div className="under-line">
                        <div className={this.state.new_line ? 'red-line' : 'gray-line'}></div>
                    </div>
                    <div className="pwd-edit-item">
                        <div className="pwd-edit">
                            <img className="img" src={AgainPwdImg} alt="" />
                            <input
                                v-model="again_pwd"
                                onFocus={this.again_pwd_foucs}
                                onBlur={this.again_pwd_blur}
                                type={this.state.again_type}
                                maxLength={20}
                                placeholder='确定密码'
                                onChange={(v) => { this.again_pwd_state(v.currentTarget.value) }}
                            />
                        </div>
                        {this.state.again_pwd_see && AgainPwdIcon}
                    </div>
                    <div className="under-line">
                        <div className={this.state.again_line ? 'red-line' : 'gray-line'}></div>
                    </div>
                </div>
                <div className="pwd-button">
                    <div className="background" onClick={this.ensure_pwd}>
                        <div className="title">确定</div>
                    </div>
                </div>
            </div>
        )
    }
}